import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import {
  StoreUtil, SpecialtyUtil
} from 'doctivity-shared/utils';
import { withRouter, utcDayRange } from 'utils';

import { Icon, Typography, Tooltip } from '@mui/material';

import {
  DynamicTable,
  ReferrerSparkline,
  ProvidersTabs,
} from 'components';

import {
  loadAnalytics,
} from 'store/actions/analyticsActions';

const styles = (theme) => ({
  title: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    backgroundColor: theme.palette.primary.accent,
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  container: {
    padding: theme.spacing(3),
  },
  affiliatedIcon: {
    fontSize: 14,
    verticalAlign: 'text-top',
    color: theme.palette.secondary.main,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },

});

class ReferringProvidersPage extends React.Component {
  constructor(props) {
    super(props);

    // this controls which columns are displayed and how they are looked up in data
    this.columns = [
      {
        label: '',
        key: 'is_affiliated',
        style: { width: 14 },
        sortable: false,
        showFilter: false,
        format: (is_affiliated) => {
          if (is_affiliated) {
            return (
              <Tooltip
                placement='bottom-start'
                title={
                  <Typography
                    style={{
                      fontSize: 13,
                      fontWeight: 200,
                    }}
                  >
                    Affiliated Provider
                  </Typography>
                }
              >
                <div
                  style={{
                    width: 14,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Icon className={props.classes.affiliatedIcon}>hub</Icon>
                </div>
              </Tooltip>
            );
          }
          return <></>;
        },
      },
      {
        label: 'Last Name',
        key: 'referrer.last_name',
        fulltext: true,
        style: { minWidth: 100 },
      },
      {
        label: 'First Name',
        key: 'referrer.first_name',
        fulltext: true,
        style: { minWidth: 100 },
      },
      {
        label: 'Credential',
        key: 'referrer.credential',
        style: { width: 105, minWidth: 105, maxWidth: 105 },
        format: (value) => (
          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: 105 }} title={value}>
            {value}
          </div>
        ),
      },
      {
        label: 'NPI',
        key: 'referrer.npi',
        style: { width: 90, minWidth: 90, maxWidth: 90, verticalAlign: 'top' },
      },
      {
        label: 'Specialty',
        key: 'referrer.taxonomy.classification',
        style: { minWidth: 200 },
        format: (classification, row) => {
          return row.referrer?.taxonomy
            ? SpecialtyUtil.getNameFromTaxonomy(row.referrer.taxonomy)
            : '';
        },
      },
      {
        label: 'Organization',
        key: 'referrer.location.organization.name',
        fulltext: true,
        hideForMobile: true,
        style: { minWidth: 220 },
      },
      {
        label: 'Referrals',
        key: 'count_referrer_id',
        style: { width: 100 },
      },
      {
        label: 'Trend',
        key: 'referrer_id',
        format: (id) => {
          if (id) {
            return <ReferrerSparkline providerId={id} />;
          }
          return 'nope';
        },
        style: { width: 60 },
        sortable: false,
      },
    ];

    this.state = {
      query: {
        limit: 25,
        offset: 0,
        order: [['count_referrer_id', 'DESC']],
      },
    };
  }

  componentDidMount() {
    const { providers } = this.props;

    if (StoreUtil.needsLoadNoCache(providers)) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps) {
    // is object getting edited?
    if (
      this.props.app.selectedClient !== prevProps.app.selectedClient ||
      this.props.app.dateRange !== prevProps.app.dateRange
    ) {
      this.fetchData();
    }
  }

  fetchData() {
    const { dispatch } = this.props;

    dispatch(
      loadAnalytics({
        type: 'TOP_REFERRERS',
        filter: {
          client_id: this.props.app.selectedClient,
          ...utcDayRange(this.props.app.dateRange),
        },
        opts: {
          limit: this.state.query.limit,
          offset: this.state.query.offset,
          order: this.state.query.order,
        },
      })
    );
  }

  render() {
    const { classes, providers } = this.props;

    const { query } = this.state;

    return (
      <>
      <title>Providers</title>
      <div className={classes.title}>
        <Typography className={classes.headerTitle}>Providers</Typography>

      </div>
        <ProvidersTabs tab='referring_providers' />
        <div className={classes.container}>
          <DynamicTable
            header='Referring Providers'
            showFilters={false}
            columns={this.columns}
            idKey='referrer_id'
            query={query}
            data={providers}
            onQueryChange={this.onQueryChange}
            getRowHref={this.getRowHref}
          />
        </div>
      </>
    );
  }

  getRowHref = (row) => {
    return `/providers/${row.referrer_id}`;
  };

  onQueryChange = (query) => {
    this.setState({ query }, () => {
      this.fetchData();
    });
  };
}

ReferringProvidersPage.propTypes = {
  router: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  providers: PropTypes.object.isRequired,
  classes: PropTypes.object,
  app: PropTypes.object,
};

function mapStateToProps(state) {
  const {
    app,
    analytics,
  } = state;

  return {
    app,
    providers: StoreUtil.get(analytics, 'TOP_REFERRERS'),
  };
}

const styled = withStyles(styles)(ReferringProvidersPage);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as ReferringProvidersPage };
